<template>
  <div>
    <form-filtered-select
      :selected-key="selectedCountry ? selectedCountry.value : null"
      :options="countryOptions"
      :invalid="invalid"
      placeholder="Country"
      @updateDropdownValue="onUpdateValue"
      @close="$emit('close')" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    value: {
      type: Object,
      default: null
    },
    invalid: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      selectedCountry: null
    }
  },
  computed: {
    ...mapGetters('country', ['countryOptions'])
  },
  watch: {
    value: function () {
      if (this.selectedCountry && this.value.value !== this.selectedCountry.value) {
        this.selectedCountry = this.value
      }
    }
  },
  mounted () {
    this.selectedCountry = this.value
    this.$watch('selectedCountry', function () {
      this.$emit('input', this.selectedCountry)
    })
  },
  methods: {
    onUpdateValue (value) {
      this.selectedCountry = value
    }
  }
}
</script>

<style lang="scss">
.multiselect {
  &__content-wrapper {
    z-index: 3000 !important;
  }
}
</style>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
